import { Alert, Button, Input, Space, Typography } from "@arco-design/web-react";
import type { QuickItineraryDetailsEditor } from "../runtime/useQuickItineraryDetails";

/** 桌面和手机共用的计调额外要求编辑区。 */
export function CustomizationQuickItineraryDetails({ editor }: { editor: QuickItineraryDetailsEditor }) {
  if (!editor.visible) return null;
  return (
    <section aria-label="快速制作行程详情" style={{ padding: 16, display: "grid", gap: 8 }}>
      <Typography.Text bold>快速制作行程详情</Typography.Text>
      <Input.TextArea
        aria-label="快速制作行程详情输入框"
        value={editor.value}
        onChange={editor.setValue}
        disabled={editor.loading || editor.saving || editor.loadFailed}
        autoSize={{ minRows: 4, maxRows: 12 }}
        maxLength={10000}
        placeholder="可填写每天的安排，或其他需要智能体处理的额外要求。"
      />
      <Space>
        <Button size="small" type="primary" loading={editor.saving}
          disabled={editor.loading || editor.loadFailed || !editor.dirty} onClick={() => { void editor.save(); }}>
          保存额外要求
        </Button>
        <Typography.Text type="secondary">
          {editor.loading ? "正在读取" : editor.dirty ? "尚未保存" : "生成行程时会自动带入"}
        </Typography.Text>
      </Space>
      {editor.error ? <Alert type="error" content={editor.error} action={
        <Button size="mini" onClick={() => {
          void (editor.loadFailed ? editor.retry() : editor.save());
        }}>重试</Button>
      } /> : null}
    </section>
  );
}
